{
    "longSHA": "1c6b78b157ee1283537622033e0d7c538b07842e",
    "shortSHA": "1c6b78b",
    "branch": "development",
    "authorName": "Damjan Tonkli",
    "commitTime": "Thu Dec 18 10:44:28 2025 +0000",
    "commitMsg": "Merge branch 'dominiks/random_fix' into 'development'\n\nfix: allow more than one record to be added in...\n\nSee merge request billing/billing-rijeka!340",
    "totalCommitCount": "1"
}